import graphql from 'babel-plugin-relay/macro';
import React from 'react';
import {useLazyLoadQuery} from 'react-relay/hooks';
import {usePerPage} from 'src/hooks/usePerPage';
import {withSuspense} from 'src/utils/withSuspense';

import {listPagegeneralAssetsQuery} from './__generated__/listPagegeneralAssetsQuery.graphql';
import GeneralAssetsTable from './GeneralAssetsTable';

function ListPage() {
  const {perPage} = usePerPage();
  const data = useLazyLoadQuery<listPagegeneralAssetsQuery>(
    generalAssets,
    {first: perPage * 2},
    {fetchPolicy: 'store-and-network'},
  );

  return <GeneralAssetsTable generalAssets={data} />;
}

export default withSuspense(ListPage);

const generalAssets = graphql`
  query listPagegeneralAssetsQuery($first: Int!) {
    ...GeneralAssetsTable_generalAssets @arguments(first: $first)
  }
`;
